import DashSectionTitle from '../../components/dashSectionTitle';
import { BoxProportion } from "../../components/non_d3/boxProportion";
import { Grid } from "../../components/non_d3/grid";
import { CountryInfo, BoxPair, ChartAndCaption } from "../../components/BoxPair";
import { ChartFlexRow } from "../../components/ChartFlexRow";
import { DonutWrappedInDiv } from "../../components/d3/donut";
import { DialWrappedInDiv } from "../../components/d3/dial";
import { BarPair } from "../../components/barPair";
import { BarWrappedInDiv } from "../../components/non_d3/boxProportion";
import { ComparisonBar } from "../../components/non_d3/comparison_bar";
import { SimpleBarAndLabelPair } from "../../components/non_d3/barsAndLabels";
import { MdSignalCellularConnectedNoInternet1Bar } from "react-icons/md";
import { GrTechnology } from "react-icons/gr";
import { ImPowerCord } from "react-icons/im";

function Content({ animateGraphs, fetchTitle, fetchReasonTitle, primaryCountry, secondaryCountry, fetchQuestionProportion, fetchQuestionPercent, cc_Ref  }) {
  return (
    <div ref={cc_Ref}>
      <ChartFlexRow>
        <ChartAndCaption caption={fetchTitle("38.1", "Story")}>
          <BoxPair>
            <Grid
              percentInt={fetchQuestionPercent(primaryCountry, "38.1")}
              fillCol="#0346AD"
              emptyCol="#fff"
              cellMargin="1px"
              borderRadius="50%"
            />
            <CountryInfo countryName={primaryCountry.name} perc={fetchQuestionPercent(primaryCountry, "38.1")} />
            <Grid
              percentInt={fetchQuestionPercent(secondaryCountry, "38.1")}
              fillCol="#A1ACFD"
              emptyCol="#fff"
              cellMargin="1px"
              borderRadius="50%"
            />
            <CountryInfo countryName={secondaryCountry.name} perc={fetchQuestionPercent(secondaryCountry, "38.1")} />
          </BoxPair>
        </ChartAndCaption>
        <ChartAndCaption caption={fetchTitle("38.2", "Story")}>
          <BarPair>
            <BarWrappedInDiv   proportion={fetchQuestionProportion(primaryCountry, "38.2")} boxFill="#0346AD" {...{animateGraphs}}/>
            <CountryInfo countryName={primaryCountry.name} perc={fetchQuestionPercent(primaryCountry, "38.2")}/>
            <BarWrappedInDiv   proportion={fetchQuestionProportion(secondaryCountry, "38.2")} boxFill="#A1ACFD" {...{animateGraphs}}/>
            <CountryInfo countryName={secondaryCountry.name} perc={fetchQuestionPercent(secondaryCountry, "38.2")}/>
          </BarPair>
        </ChartAndCaption>
        <ChartAndCaption caption={fetchTitle("38.3", "Story")}>
            <ComparisonBar
                primary_data={{name: primaryCountry.name, value: fetchQuestionPercent(primaryCountry, "38.3"), color: "#0346AD"}}
                secondary_data={{name: secondaryCountry.name, value: fetchQuestionPercent(secondaryCountry, "38.3"), color: "#A1ACFD"}}
            />
        </ChartAndCaption>
        <ChartAndCaption caption={fetchTitle("38.4", "Story")}>
            <BoxPair>
                <DonutWrappedInDiv percent={fetchQuestionPercent(primaryCountry, "38.4")} arcFill="#0346AD" {...{animateGraphs}}/>
                <CountryInfo countryName={primaryCountry.name} center />
                <DonutWrappedInDiv percent={fetchQuestionPercent(secondaryCountry, "38.4")} arcFill="#A1ACFD" {...{animateGraphs}}/>
                <CountryInfo countryName={secondaryCountry.name} center />
            </BoxPair>
        </ChartAndCaption>
      </ChartFlexRow>
   
    </div>
  );
}

export default Content;
